import {Component, Injector, Input} from "@angular/core";
import {provideSearchModel} from "@fedeltapointofsale/data-client";
import {
    registerSelectEditControl
} from "../../../framework/entity/edit/edit-controls/select-edit-controls/abstract-select-edit-control.component";
import {MetaTagType} from "../meta-tag.data";
import {
    AbstractSingleSelectEditControlComponent
} from "../../../framework/entity/edit/edit-controls/select-edit-controls/abstract-single-select-edit-control.component";
import {
    PreparationModifierValuesSearchModel
} from "../../preparation-modifier/preparation-modifier-values-search-model.service";
import {
    PreparationModifierValuesSearchPageComponent
} from "../../preparation-modifier/preparation-modifier-values-search-page/preparation-modifier-values-search-page.component";

@Component({
    selector: "wbo-product-modifier-values-single-select-edit-control",
    templateUrl: "../../../framework/entity/edit/edit-controls/select-edit-controls/single-select-edit-control.component.html",
    providers: [
        registerSelectEditControl(MetaTagValuesSingleSelectEditControlComponent),
        provideSearchModel(PreparationModifierValuesSearchModel)
    ]
})
export class MetaTagValuesSingleSelectEditControlComponent extends AbstractSingleSelectEditControlComponent<PreparationModifierValuesSearchModel> {

    private _type: MetaTagType;

    constructor(model: PreparationModifierValuesSearchModel, injector: Injector) {
        super(model, injector, "metaTagValueId", "name");
        this.extendedSearchComponent = PreparationModifierValuesSearchPageComponent;
    }

    get type(): MetaTagType {
        return this._type;
    }

    @Input()
    set type(value: MetaTagType) {
        this._type = value;
        this.model.filter["type"] = value;
    }
}
